export class IdentityUserAccountsErrorCodes {
  public static USER_EMAIL_IS_IN_USE = 'ACCOUNTS_IDENTITY_USER_EMAIL_IS_IN_USE';
}
